import React, { useState, useEffect } from "react";

function getZoomLevel() {
    if (navigator.userAgent.includes("Mac")) {
        return window.outerWidth / window.innerWidth;
    }
    return window.devicePixelRatio;
}

function Size() {
    const [windowDetails, setWindowDetails] = useState({
        adjustedWidth: window.outerWidth,
        adjustedHeight: window.outerHeight,
        zoom: getZoomLevel(),
    });

    useEffect(() => {
        function updateSizes() {
            const zoom = getZoomLevel();
            setWindowDetails({
                adjustedWidth: window.outerWidth,
                adjustedHeight: window.outerHeight,
                zoom,
            });
        }

        // Attach the resize listener
        window.addEventListener("resize", updateSizes);

        // Initial call to set sizes
        updateSizes();

        // Cleanup listener on component unmount
        return () => window.removeEventListener("resize", updateSizes);
    }, []);

    const { adjustedWidth, adjustedHeight, zoom } = windowDetails;

    return (
        <div className="information_card">
            <h3>Window size</h3>
            <p
                className="information"
                data-window-details={`${adjustedWidth} x ${adjustedHeight}`}
            >
                {`${adjustedWidth} x ${adjustedHeight}`}
            </p>
        </div>
    );
}

export default Size;
